import checkDomainAvailability from "./checkDomainAvailability";
async function getMintingDetails(cartItems) {
  let nftsToBeMinted = [];
  for (let i = 0; i < cartItems.length; i++) {
    let item = cartItems[i];
    let isTldAvailable = await checkDomainAvailability(item.tld);
    if (isTldAvailable) nftsToBeMinted.push(item.tld);

    let tempSld = item.sld != "" || item.sld ? item.sld + item.tld : item.tld;
    let isSldAvailable = await checkDomainAvailability(tempSld);
    if (isSldAvailable) nftsToBeMinted.push(tempSld);
  }
  return nftsToBeMinted;
}
export default getMintingDetails;
